export default {
	Save: "Save",
	"Save all": "Save all",
	Rename: "Rename",
	Open: "Open",
	Edit: "Edit",
	Delete: "Delete",
	Folder: "Folder",
	"Add New": "Add New",
	"My Files": "My Files",
	Size: "Size",
	Date: "Date",
	"back to parent folder": "back to parent folder",
	Download: "Download",
	Type: "Type",
	Information: "Information",
	Files: "Files",
	Table: "Table",
	Cards: "Cards",
	Total: "Total",
	"Are you sure ?": "Are you sure ?",
	Details: "Details",
	"Enter a new name": "Enter a new name",
	Add: "Add",
	"Select something": "Select something",
	"Download file": "Download file",
	Preview: "Preview",
	Refresh: "Refresh",
	"Are you sure you want to exit without saving?":
		"Are you sure you want to exit without saving?",
	"Save before closing?": "Save before closing?",
	Copy: "Copy",
	Cut: "Cut",
	Paste: "Paste",
	"Deleting...": "Deleting...",
	"Copying...": "Copying...",
	"Moving...": "Moving...",
	Folders: "Folders",
	"Search results": "Search results",
	"Search results in": "Search results in",
	"Search files and folders": "Search files and folders",
	"Add new file": "Add new file",
	"Add new folder": "Add new folder",
	"Upload file": "Upload file",
	"Upload folder": "Upload folder",
	folder: "folder",
	file: "file",
	archive: "archive",
	audio: "audio",
	image: "image",
	video: "video",
	code: "code",
	document: "document",
	of: "of",
	used: "used",
	"Open item location": "Open item location",
	"Are you sure you want to delete": "Are you sure you want to delete",
	"these items:": "these items:",
	"this item:": "this item:",
	"Delete files": "Delete files",
	and: "and",
	"more file(s)": "more file(s)",
	"Close the editor": "Close the editor",
	"Close this file": "Close this file",
};
